import { Button, Tooltip } from '@fluentui/react-components'
import { SettingsRegular } from '@fluentui/react-icons'
import styles from './ProjectEconomyButton.module.css'

const SettingsButton = () => {
  return (
    <Tooltip content="Inställningar" relationship="label">
      <Button
        data-testid="SettingsButton"
        className={styles.projectEconomyButton}
        icon={<SettingsRegular />}
        appearance="subtle"
        onClick={() => {
          const newTabUrl: string = `${window.location.origin}/installningar`
          window.open(newTabUrl, '_blank')
        }}
      />
    </Tooltip>
  )
}

export default SettingsButton
